export function isOverflowing(el: HTMLElement): boolean {
  if (!el) return false;
  return el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight;
}
